import { FurideKanriApi } from "@/api/FurideKanriApi";

export class FurideKanriService {

  /**
  * CSVをチェックします
  * @param params
  * @returns
  */
  public async checkFurideCSV(): Promise<any> {
    const api = new FurideKanriApi();
    try {
      return await api.checkFurideCSV();
    } catch (e) {
      throw e;
    }
  }

  /**
  * CSVをダウンロードします
  * @param params
  * @returns
  */
  public async downloadFurideCSV(): Promise<any> {
    const api = new FurideKanriApi();
    try {
      return await api.downloadFurideCSV();
    } catch (e) {
      throw e;
    }
  }
}
